import { Button, TextField } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import OtpInput from 'react-otp-input';
import './otpVerification.scss';
import OtpVerificationApi from '../../apis/otp-verification/OtpVerificationApi';
import { store } from 'react-notifications-component';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router';
import routerLinks from '../app/routerLinks';
import RegisterDataContext from '../../contexts/registerData-context/RegisterDataProvider';
import OtpResendCode from '../../apis/otp-verification/OtpResendCode';
import Countdown from 'react-countdown';
import createCountdown from 'create-countdown';
import requestProject from '../../apis/request-project-api/requestProject';

const OtpVerification = ({
  package_id,
  totlePrice,
  posCount,
  DisabledId,
  DisabledValue,
  activity_id,
  sollemKey,
  values,
  onClick,
  date
}) => {
  const history = useHistory();
  const [len, setLen] = useState(6);
  const [otp, setOtp] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [userObj, setUserObj] = useState(
    Cookies.get('currentUser') ? JSON.parse(Cookies.get('currentUser')) : {}
  );
  const [timeMark, setTimeMark] = useState(false);
  const [timerDone, setTimerDone] = useState(false);
  const otpTime = 60000;
  const controller = new AbortController();

  const handleSubmitOtp = async () => {
    try {
      const res = await OtpVerificationApi(userObj.token, userObj.phone_number, otp);
      if (res.status === 200 && res?.data?.status) {
        let data = res?.data?.data;
        setErrorMessage('');
        if (data?.package_id === 1) {
          if (data.activity == 1) {
            setTimeout(() => {
              window.location.replace('https://fatoorah.fatoorah.sa/');
            }, 2000);
          } else if (data.activity == 2) {
            setTimeout(() => {
              window.location.replace('https://services.fatoorah.sa/');
            }, 2000);
          }
        } else {
          history.push(routerLinks.payPage, {
            selectedPakage: package_id,
            TotlePrice: totlePrice,
            PosCount: posCount,
            DisabledId: DisabledId,
            DisabledValue: DisabledValue,
            activity_id: activity_id,
            sollemKey: null,
            values: values
          });
        }
        store.addNotification({
          title: res?.data?.message,
          message: res?.data?.message,
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 2000,
            showIcon: true,
            onScreen: true
          }
        });
      } else {
        setErrorMessage(res?.data?.message);
        store.addNotification({
          title: 'خطأ',
          message: res?.data?.message,
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 5000,
            showIcon: true,
            onScreen: true
          }
        });
      }
    } catch (error) {
      throw error;
    }
  };

  const handleCancelReq = async () => {
    controller.abort();
  };

  const timer = createCountdown(
    {
      m: 1,
      s: 0
    },
    {
      listen: ({ hh, mm, ss }) => {
        setMinutes(mm);
        setSeconds(ss);
      },
      done: () => {
        setTimerDone(true);
      }
    }
  );
  const handleReSendCode = async () => {
    try {
      const res = await OtpResendCode(userObj.token, userObj.phone_number);
      if (res.status === 200) {
        timer.start();
        setTimeMark(true);
        setTimerDone(false);
        store.addNotification({
          title: '',
          message: res?.data?.message,
          type: 'success',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 2000,
            showIcon: true,
            onScreen: true
          }
        });
      } else {
        store.addNotification({
          title: '',
          message: res?.data?.message,
          type: 'danger',
          insert: 'top',
          container: 'top-right',
          animationIn: ['animate__animated', 'animate__fadeIn'],
          animationOut: ['animate__animated', 'animate__fadeOut'],
          dismiss: {
            duration: 5000,
            showIcon: true,
            onScreen: true
          }
        });
      }
    } catch (error) {}
  };

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      return (
        <Button className="otp-btn" onClick={() => handleReSendCode()}>
          اعاده ارسال الكود
        </Button>
      );
    } else {
      // Render a countdown
      return (
        <Button className="otp-btn" disabled>
          {minutes}:{seconds}
        </Button>
      );
    }
  };
  const handleTimer = () => {
    if (timeMark) {
      if (timerDone === true) {
        return (
          <Button className="otp-btn" onClick={() => handleReSendCode()}>
            اعاده ارسال الكود
          </Button>
        );
      } else {
        return (
          <Button className="otp-btn" disabled>
            {minutes}:{seconds}
          </Button>
        );
      }
    } else {
      return <Countdown date={date + otpTime} renderer={renderer} />;
    }
  };
  return (
    <div className="otp-container">
      <div className="otp-card">
        <h2>ادخل الكود المرسل الي الهاتف الخاص بك</h2>
        {/* <h2>تحقق من رقم الهاتف الخاص بك</h2> */}
        <p>من فضلك أدخل رمز التحقق</p>

        <OtpInput
          value={otp}
          onChange={setOtp}
          numInputs={6}
          renderInput={(props) => <input {...props} />}
        />
        {errorMessage && (
          <span className="error">{`${errorMessage}, من فضلك ادخل الكود مره اخري`}</span>

          // <div className="error-message">
          //   <span className='error'>{errorMessage}</span>
          //   <span>من فضلك ادخل الكود مره اخري</span>
          // </div>
        )}
        <div className="btn-container">
          <div className="btn-wrapper">
            {len === otp.length ? (
              <Button className="otp-btn" variant="contained" onClick={() => handleSubmitOtp()}>
                تأكيد
              </Button>
            ) : (
              <Button type="submit" disabled className="otp-btn" variant="contained">
                تأكيد
              </Button>
            )}
            {handleTimer()}
          </div>
          <div className="btn-wrapper">
            <Button
              className="otp-btn"
              onClick={() => {
                window.location.reload();
              }}
              // onClickCapture={() => handleCancelReq()}
            >
              تعديل الرقم
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtpVerification;
